import React from 'react';
const AssignmentsContext = React.createContext({});
export const AssignmentsContextProvider = AssignmentsContext.Provider;
export const AssignmentsContextConsumer = AssignmentsContext.Consumer;
export default AssignmentsContext;